/**
 * CheckoutSummary Component
 */

import { generateLicenseUsageFromComponents, getLicenseString } from '../../../redux/helpers/license';
import { getResponsiveTrackThumbnail } from '../../../utils/track';
import { bw6 } from '../../styles/colors';
import './checkout-summary.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Thumbnail from '../../atoms/images/Thumbnail';
import Heading from '../../atoms/text/Heading';
import { Span } from '../../atoms/text/Label';
import PriceTag from '../../atoms/text/PriceTag';
import CheckoutAmounts from './CheckoutAmounts';

interface IOwnProps {
  order: GQL.IOrder;
}

type CheckoutSummaryProps = IOwnProps;

const classes = new BEM('checkout__order-summary');

class CheckoutSummary extends React.Component<CheckoutSummaryProps, {}> {

  renderLineItem(order: GQL.IOrder, lineItem: GQL.ILicenseLineItem) {
    const track = lineItem.track!;
    const image = getResponsiveTrackThumbnail(track);
    const usages = lineItem.license!.usages!.map(({ components }) => generateLicenseUsageFromComponents(components!));
    const licenseString = getLicenseString(usages);
    const itemClasses = new BEM('checkout__order-summary__line-item');
    return (
      <div key={lineItem.id} {...itemClasses() }>
        <Thumbnail responsiveAssets={image} size="xsmall" {...itemClasses('image') } />
        <div {...itemClasses('info') }>
          <Heading is="h5" text={track.title!} maxTextLength={15} {...itemClasses('info__title') } />
          <Span
            text={track.artist!.name!}
            size="small"
            textColor="bw7"
            {...itemClasses('info__subtitle') }
          />
          <Span size="small" textColor={bw6} {...itemClasses('terms-title') } block>License Terms</Span>
          <Span variant="description" size="large" {...itemClasses('terms') } block>{licenseString}</Span>
        </div>
        <PriceTag
          currency={order.currency_code! as GQL.Currency}
          rate={order.currency_rate!}
          amount={lineItem.amount!}
          size="small"
          {...itemClasses('price') }
        />
      </div>
    );
  }

  render() {
    const { order } = this.props;
    const lineItems = order.license_line_items!;

    return (
      <div {...classes() }>
        <Heading is="h4" {...classes('title') }>Summary</Heading>
        {lineItems.map((item, index) => this.renderLineItem(order, item))}
        <CheckoutAmounts context="sidebar" order={order} />
      </div>
    );
  }
}

export default CheckoutSummary;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Checkout/CheckoutSummary.tsx